<template>
  <div>
    <el-dialog
      :visible.sync="addServiceDialog"
      width="50%"
      title="招生人员"
      :close-on-click-modal="false"
    >
     <el-form>
      <el-form-item
        :label="ratioTypeMap[r.type]"
        v-for="(r, i) in ratios"
        :key="i"
      >
        <div class="flex" style="width: 240px">
          <el-input
            v-model="r.ratio"
            placeholder="比例，如0.1"
            type="number"
          ></el-input>
          <el-button v-if="r.id" type="primary" @click="updateRatioInfo(r)"
            >更新</el-button
          >
          <el-button v-else type="success" @click="addRatioInfo(r)"
            >添加</el-button
          >
        </div>
      </el-form-item>
       </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addServiceDialog = false">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      addServiceDialog: false,
      ratioTypeMap: {
        formal: "正课购买",
        passive: "体验课拉新持续提成",
        owner_divi: "合伙人提成",
      },
      ratios: [],
      raletive: {},
    };
  },

  mounted() {
    
  },

  methods: {
    open(v) {
      this.raletive = v;
      if(v.manage_role == 'o_owner'){
         this.ratios = [{ ratio: "", type: "formal" },{ ratio: "", type: "passive" },{ ratio: "", type: "owner_divi" }];
      }else{
          this.ratios = [{ ratio: "", type: "formal" },{ ratio: "", type: "passive" }];
      }
     
      this.addServiceDialog = true;
      this.getRatio();
    },
    getRatio() {
      let data = {
        promoter: this.raletive.admin_id,
        role: 5,
        mechanism_id: this.raletive.mechanism_id,
        types: this.ratios
          .map((t) => {
            return t.type;
          })
          .join(","),
      };
      this.$get("/user/promoterRatio/queryListPage", data).then((res) => {
        // this.ratios = res.data.data;
        let all = [...this.ratios, ...res.data.data];
        let map = {};
        all.forEach((item) => {
          map[item.type] = item;
        });
        this.ratios = Object.values(map);
      });
    },
    updateRatioInfo(row) {
      if (row.ratio < 0 || row.ratio > 1) {
        this.$message("分成比例错误");
        return;
      }
      let data = {
        id: row.id,
        ratio: row.ratio,
      };
      this.$post("/user/promoterRatio/update", data).then((res) => {
        this.getRatio();
        this.$emit("success");
      });
    },
    addRatioInfo(row) {
      if (row.ratio < 0 || row.ratio > 1) {
        this.$message("分成比例错误");
        return;
      }
      let data = {
        promoter: this.raletive.admin_id,
        role: 5,
        mechanism_id: this.raletive.mechanism_id,
        ratio: row.ratio,
        type: row.type,
      };
      this.$post("/user/promoterRatio/insert", data).then((res) => {
        this.getRatio();
        this.$emit("success");
      });
    },
  },
};
</script>